<template>
    <div>
        <div class="white-box">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="gettingData>0" />
                <!-- 繳別 -->
                <div
                    v-else
                    class="divide-y dividr-gray-200"
                >
                    <div
                        v-if="showData.canChangeMop"
                        class="pb-2"
                    >
                        <div class="max-w-[23.5rem]">
                            <Frame
                                v-model:isOpen="isOpenPay"
                                title="繳別"
                                :is-loading-data="isLoadingData"
                            >
                                <template #data>
                                    <p>
                                        {{ showData.mopCH }}
                                    </p>
                                </template>
                                <template #custom>
                                    <div class="flex justify-between items-center mt-2">
                                        <div class="w-[12.5rem]">
                                            <Multiselect
                                                v-model="mop"
                                                class="select-base"
                                                :options="mopList"
                                                placeholder="繳別"
                                                :can-clear="false"
                                                label="mopCH"
                                                :can-deselect="false"
                                            />
                                        </div>
                                        <div class="flex justify-end mt-3">
                                            <button
                                                class="btn-text text-primary border-b border-primary"
                                                type="button"
                                                @click="cancelChangePay"
                                            >
                                                取消變更
                                            </button>
                                        </div>
                                    </div>
                                </template>
                            </Frame>
                        </div>
                    </div>
                    <!-- 目標/計畫/每期保費 -->
                    <div
                        v-if="showData.canChangePremium"
                        class="pb-2"
                    >
                        <div class="max-w-[23.5rem]">
                            <Frame
                                v-model:isOpen="isOpenPlan"
                                title="目標/計畫/每期保費"
                                :is-loading-data="isLoadingData"
                            >
                                <template #data>
                                    <p>
                                        {{ addComma(showData.premium) }}
                                    </p>
                                </template>
                                <template #custom>
                                    <div class="flex justify-between items-center mt-2">
                                        <div class="w-[12.5rem]">
                                            <input
                                                v-model.trim="premium"
                                                inputmode="numeric"
                                                autocomplete="off"
                                                class="input-base pr-6"
                                                maxlength="7"
                                                @input="validInteger(premium)"
                                            >
                                            <p class="error-msg">
                                                {{ errorMessage.premium }}
                                            </p>
                                        </div>
                                        <div class="flex justify-end mt-3">
                                            <button
                                                class="btn-text text-primary border-b border-primary"
                                                type="button"
                                                @click="cancelChangePremium"
                                            >
                                                取消變更
                                            </button>
                                        </div>
                                    </div>
                                </template>
                            </Frame>
                        </div>
                    </div>
                    <!-- 配置比例 -->
                    <div
                        v-if="showData.canChangePercent"
                        class="pb-2"
                    >
                        <Frame
                            v-model:isOpen="isOpenPercent"
                            title="配置比例"
                            button-position=" mt-2.5"
                            :is-loading-data="isLoadingData"
                            @resetValues="resetValues"
                        >
                            <template #data>
                                <CustomTable
                                    :is-border="false"
                                    :cursor-pointer="false"
                                    class="xs:text-lg"
                                >
                                    <template #thead>
                                        <tr class="hidden md:table-row">
                                            <td class="flex justify-between">
                                                <p>標的名稱</p>
                                                <p class="w-1/5 flex-shrink-0 px-3">
                                                    比例
                                                </p>
                                            </td>
                                        </tr>
                                    </template>
                                    <template #tbody>
                                        <tr
                                            v-for="(item, index) in showData.goalPremList"
                                            :key="index"
                                            class="even:bg-white"
                                        >
                                            <td>
                                                <div class="flex justify-between">
                                                    <div>
                                                        {{ `${item.fundCode} ${item.fundName}` }}
                                                    </div>
                                                    <div class="w-1/5 flex-shrink-0 px-3">
                                                        {{ item.percent }}%
                                                    </div>
                                                </div>
                                                <div
                                                    v-if="item.fundMsg.length>0"
                                                    class="bg-gray-50 px-2.5 py-1.5 md:py-2.5 text-warning text-sm xs:text-base mt-2.5"
                                                >
                                                    {{ item.fundMsg }}
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                </CustomTable>
                                <Nodata
                                    v-if="showData.goalPremList.length===0"
                                    class="mt-3"
                                >
                                    系統無資料
                                </Nodata>
                            </template>
                            <template #inputs>
                                <BankFundForm
                                    v-model:validInput="validInput"
                                    v-model:subtotal="subtotal"
                                    :data="goalPremList"
                                    :dataBase="showData.goalPremList"
                                    :bankList="bankList"
                                    autoAddRow
                                    :fundBankList="fundBankList"
                                    class="border-b border-solid"
                                    @getValidResult="getValidResult"
                                />
                            </template>
                        </Frame>
                    </div>
                </div>
            </transition>
        </div>
        <Bottombar>
            <template
                v-if="showData.canChangePercent"
                #top
            >
                <div class="text-xs py-1">
                    剩餘可分配比例：
                </div>
                <div class="text-base xs:text-lg py-1">
                    {{ subtotal }}%
                </div>
            </template>
            <template
                v-if="showData.canChangePercent"
                #center
            >
                <div class="text-base py-2.5">
                    剩餘可分配比例： {{ subtotal }}%
                </div>
            </template>
            <template #right>
                <ButtonNextService
                    v-model:isSubmitOk="isSubmitOk"
                    :disabled="!hasChangeData || isLoading"
                    @click="validGoNext"
                />
            </template>
        </Bottombar>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { ref, computed, reactive, toRefs, inject } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Multiselect from '@vueform/multiselect';
import ButtonNextService from '@/components/buttons/ButtonNextService.vue';
import Bottombar from '@/components/layout/Bottombar.vue';
import Loading from '@/components/Loading.vue';
import CustomTable from '@/components/table/Table.vue';
import { getFundBankInfoA1, getInfoA1, getMopInfoA1, submitA1 } from '@/apis/A1';
import { addComma } from '@/utils/number/addComma';
import { intMinMax } from '@/utils/rules/customRules';
import Frame from '@/components/collapse/CollapseFrame.vue';
import { makeSort } from '@/utils/array/makeSort';
import Skeletons from './Skeletons.vue';
import BankFundForm from '@/components/template/bankFund/BankFundForm.vue';
import dialogContnet from '@/json/dialogContent';
import Nodata from '@/components/text/EmptyData.vue';
import _ from 'lodash';

export default {
    components: {
        Multiselect,
        Bottombar,
        Loading,
        CustomTable,
        Frame,
        Skeletons,
        BankFundForm,
        ButtonNextService,
        Nodata
    },
    setup() {
        const $vfm = inject('$vfm');
        const store = useStore();
        const route = useRoute();
        const isOpenPay = ref(false);
        const isOpenPercent = ref(false);
        const isOpenPlan = ref(false);
        const isLoadingData = ref(false);
        const isSubmitOk = ref(false);
        const validInput = ref(false);
        const subtotal = ref(0);
        const loadingCount = ref(0);
        const gettingData = ref(0);
        const isLoading = computed(() => loadingCount.value !== 0);
        const { code } = route.meta;
        const bankList = ref([]);
        const fundBankList = ref([]);
        const mopList = ref([]);
        const showData = ref({
            mop: '',
            premium: '',
            goalPremList: [],
        });
        const userData = reactive({
            mop: '',
            premium: null,
            errorMessage: {
                mop: '',
                premium: '',
            },
            goalPremList: [],
        });
        const state = reactive({
            isSubmissionNote: false,
        });

        const result = computed(() => {
            const vuexData = store.state.services.changeItemsResult[code];
            return vuexData ? _.cloneDeep(vuexData) : undefined;
        });

        /** 驗證繳費 */
        const validInteger = (value) => {
            if (!value || value === '0') {
                userData.errorMessage.premium = '請輸入目標/計畫/每期保費';
            } else {
                // userData.errorMessage.premium = integer(value) || minMax(value, 2000, 9999999, '', '目標保費須大於2,000元');
                const { val, errorMessage } = intMinMax({
                    value: value,
                    minNum: 0,
                    maxNum: 9999999,
                    minMaxMsg: '',
                });
                userData.errorMessage.premium = errorMessage;
                userData.premium = val;
            }
        };

        /** 取消變更-繳別 */
        const cancelChangePay = () => {
            isOpenPay.value = false;
            userData.mop = showData.value.mop;
        };

        /** 取消變更－目標/計畫/每期保費 */
        const cancelChangePremium = () => {
            isOpenPlan.value = false;
            userData.premium = showData.value.premium;
            userData.errorMessage.premium = '';
        };

        /** 取消變更-配置比例 */
        const resetValues = () => {
            isOpenPercent.value = false;
            userData.goalPremList = resetForm(showData.value.goalPremList);
        };

        /** 取消變更配置比例 */
        const resetForm = (baseList) => {
            const arr = _.cloneDeep(baseList);
            return arr.map(i => {
                i.dbData = true;
                i.errorMessage = {};
                if (i.disableType === 3) {
                    i.maxPercent = i.percent;
                }
                if (i.disableType === 0 || i.disableType === 2) {
                    i.disabledPercent = true;
                }
                return i;
            });
        };

        /** 取得頁面資料 */
        const getData = () => {
            gettingData.value = 3;
            /** 選單資料 */
            getFundBankInfoA1().then(res => {
                bankList.value = res.data.bankList.map(i => {
                    i.value = i.bankNo;
                    return i;
                });
                fundBankList.value = res.data.fundBankList.map(i => {
                    i.value = i.fundCode;
                    i.label = `${i.fundCode} ${i.fundName} (${i.fundTypeCH})`;
                    return i;
                });
            }).finally(() => {
                gettingData.value -= 1;
            });
            /** 繳別選單 */
            getMopInfoA1().then(res => {
                mopList.value = res.data.mopList.map(i => {
                    i.value = i.mop;
                    return i;
                });
            }).finally(() => {
                gettingData.value -= 1;
            });

            /** user資料 */
            getInfoA1().then(res => {
                // canChangeMop 為false時要隱藏繳別與配置比例
                const { mop, premium, goalPremList, mopCH, canChangeMop, canChangePremium, canChangePercent } = res.data;
                showData.value = _.cloneDeep({
                    mop, mopCH, premium, goalPremList, canChangeMop, canChangePremium, canChangePercent
                });
                userData.mop = mop;
                userData.premium = premium;
                userData.goalPremList = resetForm(goalPremList);
            }).finally(() => {
                gettingData.value -= 1;
            });
        };
        /** 製作只有fundCode percent 物件的陣列 */
        const makeArray = (ary) => {
            let list = [];
            if (ary && ary.length > 0) {
                const ls = ary.map(i => {
                    return {
                        fundCode: i.fundCode,
                        percent: i.percent
                    };
                });
                list = [...ls];
            }
            return list;
        };
        if (!result.value) {
            getData();
        } else {
            const { storeFundBankList, storeShowData, storeMopList, storeBankList } = result.value;
            const { mop, premium, goalPremList } = result.value.storeUserData;
            bankList.value = storeBankList;
            fundBankList.value = storeFundBankList;
            mopList.value = storeMopList;
            showData.value = _.cloneDeep(storeShowData);
            userData.mop = mop;
            userData.premium = premium;
            userData.goalPremList = goalPremList;
            isOpenPay.value = showData.value.mop !== userData.mop;
            isOpenPlan.value = showData.value.premium !== userData.premium;
            let showList = makeArray(showData.value.goalPremList);
            let userList = makeArray(userData.goalPremList);
            userList = makeSort(userList, 'fundCode');
            showList = makeSort(showList, 'fundCode');
            isOpenPercent.value = JSON.stringify(showList) !== JSON.stringify(userList);
        }

        /** 資料異動檢查 */
        const hasChangeData = computed(() => {
            const { goalPremList, mop, premium } = showData.value;
            let showList = makeArray(goalPremList);
            let userList = makeArray(userData.goalPremList);
            userList = makeSort(userList, 'fundCode');
            showList = makeSort(showList, 'fundCode');
            const dbDate = `${mop}${premium}${JSON.stringify(showList)}`;
            const changeDate = `${userData.mop}${userData.premium}${JSON.stringify(userList)}`;
            return dbDate !== changeDate;
        });

        /** 下一步 檢查錯誤與是否有修改資料 */
        const validGoNext = () => {
            if (showData.value.canChangePercent) {
                validInput.value = true;
            } else {
                submitData();
            }
            // validInput.value = true;
        };
        // hasFormError=false ,繼續檢查其他欄位
        const getValidResult = (hasFormError, list) => {
            if (!hasFormError) {
                if (userData.errorMessage.premium) {
                    modalShow(dialogContnet.validateMsg);
                } else {
                    submitData(list);
                }
            }
        };

        /** 送出資料 */
        const submitData = (dataList) => {
            loadingCount.value = 1;
            const { mop, premium } = userData;
            const returnData = {
                mop,
                premium,
                goalPremList: dataList ? makeArray(dataList) : [],
                ...(state.isSubmissionNote ? { ifPayingMessage: true } : {})
            };
            submitA1(returnData).then(res => {
                loadingCount.value -= 1;
                const { confirmMsgList } = res.data;
                const list = {
                    storeBankList: bankList.value,
                    storeFundBankList: fundBankList.value,
                    storeShowData: showData.value,
                    storeUserData: {
                        mop,
                        premium,
                        goalPremList: dataList
                    },
                    storeMopList: mopList.value,
                };

                if(res.data.submissionNote && !state.isSubmissionNote) {
                    var params = {
                      content: `${res.data.submissionNote}`.replace(/\n/g,"<br>"),
                      confirmButton: '確認',
                      cancelButton: null,
                      closeicon: false
                    };
                    investModalShow(params); // 顯示錯誤提示
                    state.isSubmissionNote = true;
                    return;
                }

                store.dispatch('services/setChangeItemsResult', { code, value: list });

                if (confirmMsgList.length === 0) {
                    isSubmitOk.value = true;
                } else {
                    let content = '';
                    confirmMsgList.forEach(msg => {
                        content += `<li>${msg}</li>`;
                    });

                    modalShow({
                        id: 'confirmMsgList',
                        title: '請確認',
                        content: `<ul class="list-disc pl-5">${content}</ul>`,
                        confirmButton: '確認',
                        closeicon: false,
                    });
                }
            }).catch(() => {
                loadingCount.value -= 1;
            });
        };

        const modalShow = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        if (params.id === 'confirmMsgList') {
                            isSubmitOk.value = true;
                        }
                        $vfm.hide('DialogBase');
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    }
                },
            });
        };

        const investModalShow = (params,vl) => {
            $vfm.show({
                component: 'InvestDialog',
                params,
                on: {
                    confirm() {
                        $vfm.hide('InvestDialog');
                        if(vl())vl();
                    },
                    closed() {
                        $vfm.hide('InvestDialog');
                    }
                },
            });
        };

        return {
            ...toRefs(userData),
            isOpenPay,
            isOpenPercent,
            isOpenPlan,
            isLoading,
            isLoadingData,
            validGoNext,
            validInteger,
            fundBankList,
            mopList,
            showData,
            subtotal,
            bankList,
            cancelChangePay,
            cancelChangePremium,
            addComma,
            hasChangeData,
            gettingData,
            isSubmitOk,
            validInput,
            getValidResult,
            resetValues
        };
    },
};
</script>
